import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { File } from "@ionic-native/file/ngx";
import { SharedDataService } from "src/app/services/shared-data.service";
import { UtilService } from "src/app/services/util.service";
import { ApiService } from "src/app/services/api.service";
import { FilehandlerService } from "src/app/services/filehandler.service";


@Component({
  selector: "app-archived-item",
  templateUrl: "./archived-item.component.html",
  styleUrls: ["./archived-item.component.scss"],
})
export class ArchivedItemComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() icon: string;
  @Input() colFirst: string;
  @Input() colSecond: string;
  @Input() colSecondHighlighted: string;
  @Input() colThird: string;
  @Input() colThirdHighlighted: string;
  @Input() colForth: string;
  @Input() colForthHighlighted: string;
  @Input() colFifth: string;
  @Input() colFifthHighlighted: string;
  @Input() colSixth: string;
  @Input() colSixthHighlighted: string;
  @Output() itemSelect = new EventEmitter<void>();

  constructor(
    private sharedDataService: SharedDataService,
    private file: File,
    public utilService: UtilService,
     private filehandlerService: FilehandlerService,
     public apiService: ApiService,
  ) {}

  ngOnInit() {}

  fetchAndOpenDocument(item) {
    this.apiService.getDocumentDirectoryFilePath(item.documentFileName).subscribe(
        (path) => {
            const fileData = {
                path: path,
                title: item.documentFileName,
                isSigned: true,
                signee: '',
                timeSigned: item.issuedDate,
                formTitle: item.formTitle,
                documentID: item.documentID,
                formID: null, // Removed formID as it's from another API
                formData: null // Removed formData as it's from another API
            };
            this.utilService.hideLoading();
            this.filehandlerService.openPdfInDM(fileData);
        },
        (err) => {
            this.utilService.hideLoading();
        }
    );
}
}
